var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emotional_movements"},[_c('titleTem',{attrs:{"passTitleData":_vm.passTitleData}}),_c('div',{staticClass:"echarts_container"},[_c('ETimeLine',{attrs:{"echartsData":_vm.echartsData,"isNodata":_vm.isNodata},on:{"onEveryLine":_vm.onEveryLine}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }